import type { MedicationGetAllResponse } from '@quromedical/models';
import {
  baseMedicationColumns,
  getDataFromResponse,
  type MedicationTableData,
} from 'core/medication';
import { PaginatedTable } from 'core/table';
import type { FetcherOptions } from 'hooks/usePaginatedData';
import { useResponsive } from 'hooks/useResponsive';
import { MedicationApi } from 'integration/aggregate';
import type React from 'react';
import { useCallback } from 'react';

const api = new MedicationApi();

interface MedicationsTableProps {
  patientId: string;
}

export const MedicationTable: React.FC<MedicationsTableProps> = ({
  patientId,
}) => {
  const isStriped = useResponsive({ md: true }, false);
  const fetcher = useCallback(
    (options?: FetcherOptions) => {
      return api.getMedicationStatements({
        subject: patientId,
        status: 'active',
        pageToken: options?.nextToken,
        ...options,
      });
    },
    [patientId],
  );

  const swrKey = api.getMedicationSWRKey(patientId);

  return (
    <PaginatedTable<Partial<MedicationTableData>, MedicationGetAllResponse>
      cacheKey={`medication-table-${swrKey}`}
      fetcher={fetcher}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      columns={baseMedicationColumns}
      showHeader={true}
      isStriped={isStriped}
      getDataFromResponse={getDataFromResponse}
      canChangeCount
    />
  );
};
